module.exports = __webpack_public_path__ + "img/VisionAssign.20485b2d.svg";